<template>
  <div>
    <portal to="mobileMenuButton">
      <v-btn icon @click.prevent="$router.push('/cliente/' + $route.params.id)">
        <app-icon>navigate_before</app-icon>
      </v-btn>
    </portal>
    <CustomerFormSection :customer="customer" @store="select()" />
  </div>
</template>

<script>

import CustomerFormSection from '../../components/customers/forms/CustomerFormSection.vue'

export default {

  components: { CustomerFormSection },

  data: () => ({
    customer: {},
  }),

  created() {
    this.select()
  },

  methods: {
    async select() {
      this.$loading.start();

      await this.$http
        .show("customer/customer", this.$route.params.id)
        .then((response) => {
          this.customer = response.customer;
          this.$loading.finish();
        })
        .catch((error) => {
          this.$loading.finish();
        });
    },
  },
};
</script>

<style></style>
